(function() { module.exports = this["React"]; }());